<template>
    <div v-if="isOpen" class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" ref="target">
                <div class="modal-header">
                    <slot name="header"> default header </slot>
                </div>
                <div class="modal-body">
                    <slot name="content"> default content </slot>
                </div>
                <div class="modal-footer" v-if="!withoutFooter">
                    <slot name="footer">
                        <div>
                            <button @click.stop="emit('modal-close')">Close</button>
                        </div>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onClickOutside } from '@vueuse/core'

const props = defineProps({
    isOpen: Boolean,
    withoutFooter: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['modal-close'])

const target = ref(null)
onClickOutside(target, () => emit('modal-close'))

function handleModalKeydown(e) {
    // console.debug('UIModal keypress')
    if (e.key === 'Escape') emit('modal-close')
}

// watch(
//   () => props.isOpen,
//   (io) => {
//     if (io) {
//       console.log('adding modal ESC listener')

//       useNuxtApp().callHook('editor:generic-modal:open'); // to disable on-editor keyboard listeners
//       useNuxtApp().callHook('editor:pause-animation'); // to pause animation in editor and minimize distraction

//       document.addEventListener('keydown', handleModalKeydown);
//     } else {
//       console.log('removing modal ESC listener')
//       document.removeEventListener('keydown', handleModalKeydown);

//       useNuxtApp().callHook('editor:generic-modal:close'); // to re-add on-editor keyboard listeners
//     }
//   }
// );

onMounted(() => {
    // console.log('adding modal ESC listener')

    useNuxtApp().callHook('editor:generic-modal:open') // to disable on-editor keyboard listeners
    useNuxtApp().callHook('editor:pause-animation') // to pause animation in editor and minimize distraction

    document.addEventListener('keydown', handleModalKeydown)
})

onBeforeUnmount(() => {
    // document.removeEventListener('keydown', handleModalKeydown);
    // console.log('removing modal ESC listener')
    document.removeEventListener('keydown', handleModalKeydown)

    useNuxtApp().callHook('editor:generic-modal:close') // to re-add on-editor keyboard listeners
    //
})

// // Cleanup on unmount
// onBeforeUnmount(() => {
//   console.log('UIModal unmounting')
//   document.removeEventListener('keydown', handleModalKeydown);
// });

// // Cleanup on route change
</script>

<style>
.modal-mask {
    position: fixed;
    z-index: 800;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-container {
    /* min-width: 40vw; */
    max-width: 80vw;

    padding: 20px;
    background-color: var(--ui-bg-400, #fff);
    border-radius: 10px;
    box-shadow: var(--ui-shadow, none);

    a:not(.button):hover {
        color: black;
    }
}

.modal-footer {
    margin-top: 20px;
}
</style>
